import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import eye from '../assets/eye-gray.svg';
import eyeslash from '../assets/eye-slash-svgrepo-gray.svg';
import correct from "../assets/correct-signal-svgrepo-com.svg";

const SecurityPage = ({ setActiveTab }) => {
    const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [showPopup, setShowPopup] = useState(false);

  const isMinLength = newPassword.length >= 8;
  const hasUppercase = /[A-Z]/.test(newPassword);
  const hasLowercase = /[a-z]/.test(newPassword);
  const hasSpecialChar = /[!@#$%*]/.test(newPassword);
  const passwordsMatch = newPassword === confirmPassword;

  const showPasswordRules = newPassword.length > 0;

  const handleCancel = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
 
    setActiveTab("Account"); 
  };

  const handleUpdate = () => {
    
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
      setActiveTab("Account");
    }, 1000); 
  };

  return (
    <div className="p-6 bg-white rounded-2xl shadow-md w-full mb-8 dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
      <h2 className="text-xl font-bold mb-4 dark:text-gray-200">Password</h2>
      
      <div className="flex flex-wrap gap-4 mb-4">
        {/* Old Password */}
        <div className="relative w-full md:w-[30%]">
          <label className="block mb-1 text-md font-semibold text-black dark:text-gray-300">Old Password</label>
          <div className="relative w-full">
            <input
              type={showOldPassword ? "text" : "password"}
              placeholder="Input Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="rounded-xl px-4 py-3 pr-12 border-2 border-gray-500 w-full dark:border-gray-600 dark:bg-[#1A1A1B]  dark:text-gray-300"
            />
            <button
              type="button"
              onClick={() => setShowOldPassword(!showOldPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <img src={showOldPassword ? eye : eyeslash} className="h-6 w-6" alt="Toggle password" />
            </button>
          </div>
        </div>

        {/* New Password */}
        <div className="relative w-full md:w-[30%]">
          <label className="block mb-1 text-md font-semibold text-black dark:text-gray-300">New Password</label>
          <div className="relative w-full">
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="Input New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="rounded-xl px-4 py-3 pr-12 border-2 border-gray-500 w-full dark:border-gray-600 dark:bg-[#1A1A1B]  dark:text-gray-300"
            />
            <button
              type="button"
              onClick={() => setShowNewPassword(!showNewPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <img src={showNewPassword ? eye : eyeslash} className="h-6 w-6" alt="Toggle password" />
            </button>
          </div>
        </div>

        {/* Confirm Password */}
        <div className="relative w-full md:w-[30%]">
          <label className="block mb-1 text-md font-semibold text-black dark:text-gray-300">Confirm New Password</label>
          <div className="relative w-full">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Input Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="rounded-xl px-4 py-3 pr-12 border-2 border-gray-500 w-full dark:border-gray-600 dark:bg-[#1A1A1B]  dark:text-gray-300"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <img src={showConfirmPassword ? eye : eyeslash} className="h-6 w-6" alt="Toggle password" />
            </button>
          </div>
        </div>
      </div>

      {showPasswordRules && (
        <ul className="mb-4  ">
            {isMinLength && <li className="text-gray-800 flex gap-2 mb-2 items-center dark:text-gray-400">
                <span className="correct rounded-full">
                  <img src={correct} alt="Correct" className="w-5 h-5" />
                </span>
                Minimum 8 characters</li>}
            {hasUppercase && hasLowercase && <li className="text-gray-800 flex gap-2 mb-2 items-center dark:text-gray-400">
                <span className="correct rounded-full ">
                  <img src={correct} alt="Correct" className="w-5 h-5" />
                </span>
                Use combination of uppercase and lowercase letters</li>}
            {hasSpecialChar && <li className="text-gray-800 flex gap-2 mb-2 dark:text-gray-400">
                <span className="correct rounded-full">
                  <img src={correct} alt="Correct" className="w-5 h-5" />
                </span>
                Use special characters (!, @, #, $, %, *)</li>}
            {passwordsMatch && <li className="text-gray-800 flex gap-2 mb-2 dark:text-gray-400">
                <span className="correct rounded-full">
                  <img src={correct} alt="Correct" className="w-5 h-5" />
                </span>
                Passwords match</li>}
        </ul>
      )}

      <button
        disabled={!(isMinLength && hasUppercase && hasLowercase && hasSpecialChar && passwordsMatch)}
        onClick={handleUpdate}
        className="w-full md:w-auto px-4 py-3 text-md rounded-xl agarly-btn-primary text-agarly-dark hover:opacity-90 transition"
      >
        Update Password
      </button>
      <button
        onClick={handleCancel}
        className="md:ml-4 md:mt-0 mt-4 ml-[40%]  agarly-gradient-text font-bold"
      >
        Cancel
      </button>

      {/*pob up*/}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50 dark:bg-black">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center dark:text-gray-300">
            <h3 className="text-lg font-bold mb-2">Password Updated!</h3>
            <p>Your password has been successfully changed.</p>
          </div>
        </div>
      )}
    </div>
    
  );
};

export default SecurityPage;
